import { useNavigate } from "react-router-dom";

import List from "../../layout/List/List";
import MainBtn from "../../layout/MainBtn/MainBtn";

import { installmentPagePath } from "../../../router/path";
import { scrollTop } from "../../../utils/functions/scrollTop";
import styles from "./HomeInstallment.module.scss";

const HomeInstallment = () => {
  const navigate = useNavigate();
  return (
    <main className={styles.homeInstallment}>      
        <h2 className={`titleH2 ${styles.homeInstallment__titleH2}`}>
          Chcesz kupić mieszkanie w Bułgarii? <br />
          Interesują Cię raty?
        </h2>
        <h5 className={styles.homeInstallment__subtitle}>
          Raty zapewniamy bezpośrednio inwestor - deweloper.{" "}
        </h5>
        <h5 className={styles.homeInstallment__subtitlePrimary}>
          <i>Mieszkania na raty z zaliczką 10% bez wkładu własnego</i>
        </h5>      
      <div className={styles.homeInstallment__lists}>
        <List
          list={[
            "Okres spłaty do 10 lat",
            "Wystarczy dowód osobisty",
            "Brak sprawdzania rejestrów",
            "Brak weryfikacji dochodów",
            "Brak deklaracji podatkowych",
          ]}
        />
        <List
          list={[
            "Brak wyciągów z konta bankowego",
            "Wystarczy podpisać umowę",
            "Wpłać wybraną zaliczkę przelewem bankowym",
            "Mieszkasz lub wynajmujesz w ciągu 48 godzin",
          ]}
        />
      </div>
      <MainBtn
        className={styles.homeInstallment__btn}
        onClick={() => {
          navigate(installmentPagePath);
          scrollTop();
        }}
      >
        Więcej informacji
      </MainBtn>      
        <p className={styles.homeInstallment__endingTxt}>
          Oferujemy również transfery z i na lotnisko + zakwaterowanie od jednej
          do 4 osób całkowicie GRATIS!!!
        </p>      
    </main>
  );
};

export default HomeInstallment;
